export type UserManagementConfiguration = Readonly<{
    isLdapEnabled: boolean
    isEntraEnabled: boolean
    isMfaEnabled: boolean
}>
